import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebase2Config = {
  apiKey: process.env.REACT_APP_FB2_API_KEY,
  authDomain: process.env.REACT_APP_FB2_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB2_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB2_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB2_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB2_APP_ID,
};

// Se registra con un nombre único para coexistir con la app principal
const app2 = initializeApp(firebase2Config, 'rocharamas-retratos');

export const db2 = getFirestore(app2);
